import React from 'react';
import { AppProviders } from './components/providers/AppProviders';
import { AppRoutes } from './config/routes';

/**
 * App - Root application component
 *
 * Orchestrates:
 * - Provider composition (Auth, Organization, Toast, Municipalities)
 * - Route configuration (Public, Protected, OrgSetup routes)
 * - Application entry point
 *
 * Architecture:
 * - Thin orchestrator pattern (no business logic here)
 * - Providers in ./components/providers/AppProviders.tsx
 * - Routes in ./config/routes.tsx
 * - Layout in ./components/layout/AppLayout.tsx
 * - Modal management in ./hooks/useModalManager.ts
 * - Calendar logic in ./hooks/useCalendarLogic.ts
 */
export default function App() {
  return (
    <AppProviders>
      <AppRoutes />
    </AppProviders>
  );
}
